<template>
  <div class="time-select">
    <div class="heat-time" v-on:click="selectHeatDayOpen">
      <input type="text" :value="selectDay | dateFilter" readonly v-on:blur="keepClose" />
    </div>
    <div class="heat-time-select" v-if="heatDayShow" @mousedown="keepOpen($event)">
      <div class="heat-time-select-ym">
        <span class="left-go" @mousedown="prveSelect($event)"></span>
        <span
          class="heat-time-select-ym-value"
          @mousedown="changeSelect($event)"
        >{{ selectYear | yearFilter }}{{ selectMonth | monthFilter }}</span>
        <span class="right-go" @mousedown="nextSelect($event)"></span>
      </div>
      <transition name="yml" mode="out-in">
        <div class="heat-time-select-dayBox" v-if="selectType == 'day'" key="day">
          <div class="heat-time-select-week">
            <span>一</span>
            <span>二</span>
            <span>三</span>
            <span>四</span>
            <span>五</span>
            <span>六</span>
            <span>日</span>
          </div>
          <div class="heat-time-select-day">
            <span
              @mousedown="setSelectDay(days)"
              v-for="(days, index) in heatDay"
              :key="index"
              :class="{ selectTime: days == selectDate, liveSpan: days > 0 }"
            >{{ days }}</span>
          </div>
        </div>
        <div class="heat-time-select-monthBox" v-else-if="selectType == 'month'" key="month">
          <span v-for="m in 12" :key="m" @mousedown="setSeclectMonth($event, m)">{{ m }}月</span>
        </div>
        <div class="heat-time-select-monthBox" v-else-if="selectType == 'year'" key="year">
          <span
            v-for="y in 12"
            :key="y"
            @mousedown="setSeclectYear($event, showYear + y - 6)"
          >{{ showYear + y - 6 }}年</span>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectDay: {
      type: [String, Date],
      default: function() {
        return new Date();
      }
    }
  },
  data() {
    return {
      selectType: "day",
      // selectDay: new Date(),
      selectYear: new Date().getFullYear(),
      selectMonth: new Date().getMonth() + 1,
      selectDate: new Date().getDate(),
      heatDayShow: false
    };
  },
  methods: {
    selectHeatDayOpen() {
      this.heatDayShow = true;
      let now = new Date();
      this.selectYear = now.getFullYear();
      this.selectMonth = now.getMonth() + 1;
      if (!this.selectDate) {
        this.selectDate = now.getDate();
      }
      this.initDays();
    },
    prveSelect($event) {
      $event.preventDefault();
      if (this.selectType == "day") {
        if (this.selectMonth == 1) {
          this.selectYear--;
          this.selectMonth = 12;
        } else {
          this.selectMonth--;
        }
        this.initDays();
      } else if (this.selectType == "month") {
        this.showYear--;
        this.selectYear--;
      } else if (this.selectType == "year") {
        this.showYear--;
      }
    },
    nextSelect($event) {
      $event.preventDefault();
      if (this.selectType == "day") {
        if (this.selectMonth == 12) {
          this.selectYear++;
          this.selectMonth = 1;
        } else {
          this.selectMonth++;
        }
        this.initDays();
      } else if (this.selectType == "month") {
        this.showYear++;
        this.selectYear++;
      } else if (this.selectType == "year") {
        this.showYear++;
      }
    },
    keepOpen($event) {
      $event.preventDefault();
    },
    changeSelect($event) {
      $event.preventDefault();
      if (this.selectType == "day") {
        this.selectType = "month";
        this.selectMonth = 0;
        this.showYear = this.selectYear;
      } else if (this.selectType == "month") {
        this.selectYear = 0;
        this.selectType = "year";
      }
    },
    setSeclectYear($event, year) {
      $event.preventDefault();
      this.selectType = "month";
      this.showYear = year;
      this.selectYear = year;
    },
    setSeclectMonth($event, month) {
      $event.preventDefault();
      this.selectType = "day";
      this.selectMonth = month;
      this.selectDate = 0;
    },
    keepClose() {
      this.heatDayShow = false;
      this.selectType = "day";
    },
    initDays() {
      this.heatDay = [];
      let firstDay = new Date(
        this.selectYear,
        this.selectMonth - 1,
        1
      ).getDay();
      let lastDay = new Date(this.selectYear, this.selectMonth, 0).getDate();
      if (firstDay == 0) {
        this.heatDay.length = 6;
      } else {
        this.heatDay.length = firstDay - 1;
      }
      for (let i = 1; i <= lastDay; i++) {
        this.heatDay.push(i);
      }
    },
    setSelectDay(days) {
      if (days) {
        this.selectDate = days;
        this.heatDayShow = false;
        let dateValue =
          this.selectYear +
          "-" +
          (this.selectMonth < 10 ? "0" + this.selectMonth : this.selectMonth) +
          "-" +
          (this.selectDate < 10 ? "0" + this.selectDate : this.selectDate);
        this.$emit("getDate", dateValue);
      }
    }
  },
  filters: {
    dateFilter(val) {
      if (typeof val == "string") {
        return val;
      } else {
        let y = val.getFullYear();
        let m = val.getMonth() + 1;
        let d = val.getDate();
        return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
      }
    },
    yearFilter(val) {
      if (!!val && val > 0) {
        return val + "年";
      } else {
        return "";
      }
    },
    monthFilter(val) {
      if (!!val && val > 0) {
        return val + "月";
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.time-select {
  width: 100%;
  height: auto;
  position: relative;
}
.heat-time-select {
  width: 210px;
  height: auto;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  cursor: pointer;
  border: 1px solid #fceaea;
  box-shadow: 0 0 10px #cacaca;
}

.heat-time-select-ym {
  width: 210px;
  height: 30px;
  display: flex;
}

.heat-time-select-ym-value {
  display: block;
  width: 150px;
  height: 30px;
  text-align: center;
  line-height: 30px;
}

.left-go,
.right-go {
  display: block;
  width: 30px;
  height: 30px;
  position: relative;
}

.left-go::after {
  content: "";
  width: 10px;
  height: 10px;
  border: solid #212121;
  border-width: 0 0 1px 1px;
  transform: rotate(45deg);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.right-go::after {
  content: "";
  width: 10px;
  height: 10px;
  border: solid #212121;
  border-width: 1px 1px 0 0;
  transform: rotate(45deg);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.heat-time-select-dayBox {
  width: 210px;
  height: auto;
  position: relative;
  display: flex;
  flex-direction: column;
}

.heat-time-select-week {
  width: 210px;
  height: 30px;
  display: flex;
}

.heat-time-select-week span,
.heat-time-select-day span {
  display: block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #212121;
  text-align: center;
}

.heat-time-select-day {
  width: 210px;
  height: auto;
  display: flex;
  flex-wrap: wrap;
}

.heat-time-select-day span.liveSpan:hover {
  color: #ffffff;
  background-color: #0b4564;
}

.heat-time-select-day span.selectTime {
  color: #ffffff;
  background-color: #20a0ba;
  border-radius: 50%;
}

.heat-time-select-monthBox {
  width: 210px;
  height: 200px;
  display: flex;
  flex-wrap: wrap;
}

.heat-time-select-monthBox span {
  width: 70px;
  height: 50px;
  display: block;
  text-align: center;
  line-height: 50px;
  font-size: 14px;
  color: #212121;
}

.heat-time-select-monthBox span:hover {
  color: #ffffff;
  background-color: #0b4564;
}

/* .heat-time-select-monthBox span.selectMonth,
.heat-time-select-monthBox span.selectYear {
  color: #ffffff;
  background-color: #20a0ba;
  border-radius: 50%;
} */

.yml-enter-active {
  animation: yml-out 0.5s reverse;
}

.yml-leave-active {
  animation: yml-out 0.5s;
}

@keyframes yml-out {
  from {
    opacity: 1;
    transform: scale(1);
  }

  to {
    opacity: 0;
    transform: scale(0.8);
  }
}
.heat-time {
  width: 100%;
  height: 100%;
  color: #ffffff;
  font-size: 14px;
  align-items: flex-end;
  position: relative;
}

.heat-time::after {
  content: "";
  width: 5px;
  height: 5px;
  border: solid #28465c;
  border-width: 0 1px 1px 0;
  position: absolute;
  bottom: 0;
  right: 5px;
  top: 0;
  margin: auto;
  transform: translate(-50%, -50%) rotate(45deg);
}

.heat-time input {
  width: 100%;
  height: 40px;
  border: 0px;
  background-color: transparent;
  font-size: 14px;
  color: #28465c;
  outline: none;
  cursor: pointer;
  padding: 0 5px;
}
</style>
